import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  Signal,
  WritableSignal,
  computed,
  signal,
  inject,
} from '@angular/core';
import { DropdownEvent, DropdownItem } from '@shared/abstraction';
import { TaxResultItemType } from '@shared/enums/tax-result-item-type';
import { TransactionType } from '@shared/helpers/enums/transaction-type';
import { HeaderService } from '@shared/services';

import { ChartsService } from '@shared/services/charts.service';
import { taxResultTypeItems } from 'src/app/modules/admin/constants/tax-result-type-items';
import { transactionTypeMapItems } from 'src/app/modules/admin/constants/transaction-type-map-items';

@Component({
  standalone: false,
  selector: 'gstar-tax-impact-panel',
  templateUrl: './tax-impact-panel.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TaxImpactPanelComponent implements OnInit {
  chartService = inject(ChartsService);
  headerService = inject(HeaderService);

  transactionTypes = TransactionType;
  transactionTypeItems: WritableSignal<DropdownItem[]> = signal<DropdownItem[]>(
    transactionTypeMapItems
  );

  taxResultTypes = TaxResultItemType;
  taxResultTypeItems: WritableSignal<DropdownItem[]> =
    signal<DropdownItem[]>(taxResultTypeItems);
  isNotClientSelected: Signal<boolean> = computed(
    () => !this.headerService.selectedClient()
  );

  ngOnInit(): void {
    this.chartService.selectedTransactionType.set(transactionTypeMapItems[1]); // default: TransactionType.SpecificAdvice
    this.chartService.selectedTaxResultTypeType.set(taxResultTypeItems[0]);
  }

  onSelectTransactionType(event: DropdownEvent): void {
    const selectedItem = event.selected as unknown as DropdownItem;
    this.chartService.selectedTransactionType.set(selectedItem);
  }

  onSelectRateType(event: DropdownEvent): void {
    const selectedItem = event.selected as unknown as DropdownItem;
    this.chartService.selectedTaxResultTypeType.set(selectedItem);
  }
}
